<section class="management-page">
  <header class="page-header">
    <div>
      <h2>Team- & Mitarbeiterverwaltung</h2>

    </div>
    <div class="page-actions">
      <mat-button-toggle-group *ngIf="store.canSeeDirectory" [value]="view" (change)="setView($event.value)"
        aria-label="Ansicht">
        <mat-button-toggle value="teams"><mat-icon>groups</mat-icon> Teams</mat-button-toggle>
        <mat-button-toggle value="mitarbeiter"><mat-icon>badge</mat-icon> Alle Mitarbeiter</mat-button-toggle>
      </mat-button-toggle-group>
      <button mat-flat-button color="primary" *ngIf="store.canCreateTeam" [disabled]="store.busy || store.loading"
        (click)="createTeam()">
        <mat-icon>add</mat-icon> Team erstellen
      </button>
    </div>
  </header>

  <mat-progress-bar class="busy-bar" mode="indeterminate" *ngIf="store.busy"></mat-progress-bar>

  <p class="hint warn page-hint" *ngIf="myPrimaryMissing">
    <mat-icon>warning_amber</mat-icon>
    Du gehörst mehreren Teams an. Bitte lege in einem deiner Teams „Als mein Hauptteam“ fest – dessen Teamleitung
    genehmigt deine Urlaubsanträge.
  </p>

  <div class="loading" *ngIf="store.loading"><mat-spinner diameter="22"></mat-spinner> Teams und Mitarbeiter werden
    geladen …</div>
  <p class="hint warn page-hint" *ngIf="store.error" role="alert">
    <mat-icon>error_outline</mat-icon> {{ store.error }}
  </p>

  <!-- Ansicht A: Teams -->
  <div class="teams-layout" *ngIf="!store.loading && !store.error && view === 'teams'">
    <mat-card class="team-list">


      <h4 class="section-title">Meine Teams <span class="count">{{ myTeams.length }}</span></h4>
      <p class="list-empty" *ngIf="!myTeams.length">
        {{ teamSearch ? 'Kein eigenes Team passt zur Suche.' : 'Noch keinem Team zugeordnet.' }}
      </p>
      <ng-container *ngTemplateOutlet="teamItems; context: { $implicit: myTeams }"></ng-container>

      <ng-container *ngIf="otherTeams.length">
        <h4 class="section-title other">Weitere Teams <span class="count">{{ otherTeams.length }}</span></h4>
        <ng-container *ngTemplateOutlet="teamItems; context: { $implicit: otherTeams }"></ng-container>
      </ng-container>

      <ng-template #teamItems let-teams>
        <button type="button" class="team-item" *ngFor="let team of teams; trackBy: trackTeam"
          [class.active]="team.id === selectedTeamId" [class.inactive]="!team.isActive" (click)="selectTeam(team.id)">
          <span class="team-item-top">
            <strong>{{ team.name }}</strong>
            <span class="team-count"><mat-icon>group</mat-icon>{{ team.memberCount }}</span>
          </span>
          <small>
            <mat-icon>verified_user</mat-icon>{{ team.leaderName || 'Keine Teamleitung' }}
          </small>
          <span class="team-badges">
            <span class="badge leader" *ngIf="myRole(team).leader">Meine Leitung</span>
            <span class="badge primary" *ngIf="myRole(team).primary">Mein Hauptteam</span>
            <span class="badge muted" *ngIf="!team.isActive">Inaktiv</span>
          </span>
        </button>
      </ng-template>
    </mat-card>

    <mat-card class="team-detail">
      <app-resource-team-detail *ngIf="selectedTeam as team" [team]="team" (openProfile)="openProfile($event)"
        (edit)="editTeam($event)" (deleted)="onTeamDeleted()"></app-resource-team-detail>

      <div class="empty" *ngIf="!selectedTeam">
        <mat-icon>groups</mat-icon>
        <ng-container *ngIf="store.teams.length">Wähle links ein Team aus.</ng-container>
        <ng-container *ngIf="!store.teams.length">
          Du bist noch keinem Team zugeordnet.
          <button mat-stroked-button color="primary" *ngIf="store.canCreateTeam" (click)="createTeam()">
            <mat-icon>add</mat-icon> Erstes Team erstellen
          </button>
        </ng-container>
      </div>
    </mat-card>
  </div>

  <!-- Ansicht B: Alle Mitarbeiter -->
  <mat-card class="directory" *ngIf="!store.loading && !store.error && view === 'mitarbeiter'">
    <app-resource-employee-directory [selectedUserId]="profileUserId"
      (openProfile)="openProfile($event)"></app-resource-employee-directory>
  </mat-card>

  <!-- Mitarbeiterprofil als Seitenpanel -->
  <ng-container *ngIf="profileUserId && !store.loading">
    <div class="panel-backdrop" (click)="closeProfile()"></div>
    <aside class="profile-panel" #profileScroll role="dialog" aria-modal="true" aria-label="Mitarbeiterprofil">
      <app-resource-employee-profile [userId]="profileUserId" (closed)="closeProfile()"
        (openTeam)="showTeam($event)"></app-resource-employee-profile>
    </aside>
  </ng-container>
</section>